// @flow
import React, { Component } from 'react';

import PageHeader from '../../PageHeader.jsx';
import ContentBox from '../../ContentBox.jsx';

import VitalSignsTable from './VitalSignsTable.jsx';

class VitalSignsPage extends Component<{}> {
  render() {
    return (
      <div>
        <PageHeader title='Vital Signs' />
        <ContentBox>
          <VitalSignsTable />
        </ContentBox>
      </div>
    );
  }
}

export default VitalSignsPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/vitals/VitalSignsPage.jsx